export const nl2br = str => {
  return str.replace(/\n/g, "<br/>");
};

export const format = (str, formatters) => {
  for (let formatter of formatters) {
    str = formatter(str);
  }
  return str;
};
